import { render, staticRenderFns } from "./SuspendByClass.vue?vue&type=template&id=3f944c08&"
import script from "./SuspendByClass.vue?vue&type=script&lang=js&"
export * from "./SuspendByClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports